import { create } from 'zustand';
import { AccountApi, ApiUtils, RequestStrategyEnum, SetAccountPartnerAccountNumberRequest } from '@shared/api';

interface ISetPartnerAccountNumberStore {
  loading: boolean;
  error: string | null;
  success: boolean;
  setPartnerAccountNumber: (request: SetAccountPartnerAccountNumberRequest, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useSetPartnerAccountNumberStore = create<ISetPartnerAccountNumberStore>((set) => ({
  loading: false,
  error: null,
  success: false,

  setPartnerAccountNumber: ApiUtils.wrapperApi(async (request: SetAccountPartnerAccountNumberRequest, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      await AccountApi.setPartnerAccountNumber(request, signal);
      set({ success: true, loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ success: false, loading: false, error: null }),
}));
